import { IPHONE_MODELS, PIXEL_MODELS } from 'components/AuthRC/deviceConstants'

export const DEFAULT_DEVICE_SKU_KEY = 'default'

export const normalizeDeviceLabel = deviceLabel => {
  if (!deviceLabel) {
    return ''
  }

  return deviceLabel
    .toString()
    .trim()
    .replace(/[\u2010-\u2015]/g, '-')
    .replace(/[^a-zA-Z0-9\-\s]/g, '')
    .replace(/\s+/g, ' ')
    .toLowerCase()
}

export const toDeviceKey = normalizedLabel =>
  normalizedLabel
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')

const findModelValueByLabel = (models, label) => {
  const normalizedLabel = normalizeDeviceLabel(label)
  return models.find(model => normalizeDeviceLabel(model.label) === normalizedLabel)?.value || null
}

export const getRcDeviceKey = rcDeviceData => {
  if (!rcDeviceData?.deviceType) {
    return null
  }

  if (rcDeviceData.deviceType === 'ios') {
    if (!rcDeviceData.deviceModel) {
      return null
    }

    const matchedModel = findModelValueByLabel(IPHONE_MODELS, rcDeviceData.deviceModel)
    if (matchedModel) {
      return matchedModel
    }

    return toDeviceKey(normalizeDeviceLabel(rcDeviceData.deviceModel)) || null
  }

  if (rcDeviceData.deviceType === 'android') {
    const matchedPixelModel = findModelValueByLabel(PIXEL_MODELS, rcDeviceData.deviceModel)
    if (matchedPixelModel) {
      return matchedPixelModel
    }

    const normalizedModelKey = toDeviceKey(normalizeDeviceLabel(rcDeviceData.deviceModel))
    if (normalizedModelKey?.includes('pixel')) {
      return normalizedModelKey
    }

    const connector = rcDeviceData.deviceConnector?.toLowerCase?.()
    if (!connector) {
      return 'android'
    }

    if (connector.includes('micro')) {
      return 'android-micro-usb'
    }

    if (connector.includes('usb') || connector.includes('type')) {
      return 'android-usbc'
    }

    return `android-${connector.replace(/[^a-z0-9]+/g, '-')}`
  }

  return null
}

export const getMappedDeviceSkuKey = ({ deviceSkuMap, rcDeviceData }) => {
  const deviceKey = getRcDeviceKey(rcDeviceData)
  if (deviceKey && deviceSkuMap?.[deviceKey]) {
    return deviceKey
  }

  if (rcDeviceData?.deviceType && deviceSkuMap?.[DEFAULT_DEVICE_SKU_KEY]) {
    return DEFAULT_DEVICE_SKU_KEY
  }

  return deviceKey
}
